import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { PageTitle } from './PageTitle';
import { RoomTypes } from './OnlineMenu';
import CreateRoom from './online/CreateRoom';
import GamerTag from './GamerTag';
import FindMatch from './online/FindMatch';

import { useApplication } from '../AppContext';

const Types = {};

for (const key of Object.keys(RoomTypes)) {
	Types[key] = key;
}

const playerStats = {
	imageURL: 'assets/Avatars/vv/AvatarVV_0071.png',
	name: 'Player Name',
	rank: 0,
	rating: 100,
	inviteCode: '213904',
};

const OnlineWaitingRoom = () => {

	let { mode } = useParams();
	const app = useApplication();
	mode = mode ?? 'Find';

	const { t } = useTranslation();

	const [room, setRoom] = React.useState(undefined);
	const [players, setPlayers] = React.useState({});

	const onPlayerChange = React.useCallback((newPlayers) => {
		setPlayers(newPlayers.toJSON());
	}, []);

	const updatePlayer = React.useCallback((value, key) => {
		setPlayers((oldPlayers) => {
			const copy = {
				...oldPlayers,
			};

			if (value === null) { //null value means it's deleted
				delete copy[key];
				return copy;
			}

			return {
				...copy,
				[key]: value,
			};
		});
	}, []);

	const handleSetRoom = React.useCallback((room) => {
		setRoom(room);

		if (room?.players) {
			onPlayerChange(room.players);
		}

		room.state.players.onChange((value, key) => {
			updatePlayer(value, key);
		});

		room.state.players.onAdd((player, sessionId) => {
			//
			// A player has joined!
			//
			//TODO Should we keep this?
			if (sessionId !== room.sessionId) {
				app.showNotification(t('{{playerName}} joined!', {
					playerName: player.name,
				}));
			}
		});

		room.onMessage('start', () => {
			app.navigate(`Game/Online/${room?.roomId}`);
		});
	}, [app, onPlayerChange, t, updatePlayer]);

	const handleOnReady = React.useCallback((e) => {
		e?.stopProgagation?.();
		e?.preventDefault?.();
		room?.send?.('start');
	}, [room]);

	const playerList = React.useMemo(() => {
		const playerEntries = Object.entries(players);

		if (!playerEntries?.length) {
			return null;
		}

		return (
			<>
				<p>{t('Players in room')}</p>
				<ul className="buttonList">
					{playerEntries.map(([sessionId, player]) => {
						return (
							<li key={sessionId}>
								<GamerTag
									player={{
										...playerStats,
										name: player.name,
										avatar: player.avatar,
									}}
									showOnline
								/>
							</li>
						);
					})}
				</ul>
			</>
		);
	}, [players, t]);

	const { title, content } = React.useMemo(() => {
		switch (mode) {
			case Types.Find:
				return {
					title: t('Find a Game'),
					content: <FindMatch room={room} setRoom={handleSetRoom} />,
				};
			case Types.Create:
				return {
					title: t('Create Room'),
					content: <CreateRoom room={room} setRoom={handleSetRoom} />,
				};

		}
	}, [mode, t, handleSetRoom, room]);

	const interactionButton = React.useMemo(() => {

		if (!room || !players || (Object.keys(players)?.length ?? 0) < 2) {
			return null;
		}

		return (
			<a
				href="#"
				className="simpleButtonOutLine w-100"
				onClick={handleOnReady}
			>
				{t('Start Game?')}
			</a>
		);
	}, [handleOnReady, players, room, t]);

	return (

		<div id="JoinWithCode" className="page1">
			<div className="wrapper">
				<PageTitle returnPage="Online">
					<h1>{title}</h1>
				</PageTitle>
				<ul className="buttonList">
					{content}
					<li className="mb2">
						{interactionButton}
					</li>
				</ul>
				{playerList}
			</div>
		</div>
	);
};

export default React.memo(OnlineWaitingRoom);
